module.exports = __webpack_public_path__ + "static/img/open_btn.99a708e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/open_btn.png
// module id = VoID
// module chunks = 1 3